import * as React from "react";
import type { SVGProps } from "react";
export const SvgMiscCreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 14 14" {...props}>
    <path
      fill="currentColor"
      d="M12.836 6.417v5.25a.583.583 0 0 1-.583.583h-10.5a.583.583 0 0 1-.584-.584v-5.25h11.667Zm0-2.334H1.17v-1.75c0-.322.262-.583.584-.583h10.5c.322 0 .583.261.583.583v1.75Z"
    />
  </svg>
);
